export enum BookingEvent {
  BOOKING_STATUS_CHANGED = "BOOKING_STATUS_CHANGED",
  INIT = "INIT",
  REFRESH_MAP = "REFRESH_MAP",
}
